import { render, staticRenderFns } from "./CompensationStep.vue?vue&type=template&id=9a1fe532&scoped=true"
import script from "./CompensationStep.vue?vue&type=script&lang=js"
export * from "./CompensationStep.vue?vue&type=script&lang=js"
import style0 from "./CompensationStep.vue?vue&type=style&index=0&id=9a1fe532&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1fe532",
  null
  
)

export default component.exports